import { render, staticRenderFns } from "./PackageSlider.vue?vue&type=template&id=dd87d7a6&scoped=true"
import script from "./PackageSlider.vue?vue&type=script&lang=js"
export * from "./PackageSlider.vue?vue&type=script&lang=js"
import style0 from "./PackageSlider.vue?vue&type=style&index=0&id=dd87d7a6&prod&lang=scss&scoped=true"
import style1 from "./PackageSlider.vue?vue&type=style&index=1&id=dd87d7a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd87d7a6",
  null
  
)

export default component.exports